import { Component, OnInit, OnDestroy } from '@angular/core';
import { DashboardService } from '../share/services/dashboard/dashboard.service';
import { faDownload, faEye, faArrowUp, faArrowDown, faSort, faSpinner, faSliders, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { CompanyServiceService } from '../share/services/company-service/company-service.service';
import { StorageService } from '../share/services/storage-service/storage.service';
import { StorageKeys } from '../share/enums/storage.enum';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  private readonly filterSubject$ = new Subject<void>();
  private filterSubscription!: Subscription;
  private stockSub?: Subscription;

  stockDts: any[] = [];
  headers: any[] = [];
  data: any[] = [];
  isToster: boolean = false;
  message: any;
  isButtonDisabled: boolean = false;
  isStockListButtonDisabled: boolean = false;
  loader: boolean = false;
  filters: any = {};
  companyData: any[] = [];
  dateRange = [
    { label: 'Last 30 Days', value: 30 },
    { label: 'Last 60 Days', value: 60 },
    { label: 'Last 90 Days', value: 90 }
  ];
  showFilterPanel: boolean = false;
  isBranchVisible: boolean = false;
  filtersForm = {
    lastSale: null,
    tyreMake: '',
    tyreSize: '',
    tyreModel: '',
    branch: null as string | null
  };

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly storageService: StorageService,
    private readonly companyService: CompanyServiceService,
  ) {
    let userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.isBranchVisible = userDetailsData?.enrollmentType === 'Company';
    if (this.isBranchVisible) {
      this.getAllCompanyList();
    }
  }

  ngOnInit(): void {
    this.filterSubscription = this.filterSubject$.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.onChangeApplyFilter();
    });

    this.getAllCompanyStock();
  }

  ngOnDestroy(): void {
    if (this.filterSubscription) this.filterSubscription.unsubscribe();
    if (this.stockSub) this.stockSub.unsubscribe();
  }

  getAllCompanyStock() {
    this.loader = true;
    const params = {
      ...this.filters,
    };
    if (this.stockSub) {
      this.stockSub.unsubscribe();
    }
    this.stockSub = this.dashboardService.getCompanyStockDetails(this.stockDts, params).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.data = res.data.data;
        this.headers = res.data.headers;
      },
      error: () => {
        this.loader = false;
      }
    });
  }

  createDownloadLink(response: any) {
    const link = document.createElement('a');
    link.href = globalThis.URL.createObjectURL(response.body);
    link.download = response.headers.get('file-name');
    document.body.appendChild(link);
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: globalThis as any }));
    link.remove();
    globalThis.URL.revokeObjectURL(link.href);
    this.isButtonDisabled = false;
  }

  exportStockData() {
    this.isButtonDisabled = true;
    this.dashboardService.exportTyreStock().subscribe({
      next: (response: any) => {
        this.createDownloadLink(response);
        this.message = 'Stock-Sheet download successfully';
        this.isToster = true;
      },
      error: () => {
        this.isButtonDisabled = false;
      }
    });
  }

  closeToster(event: any) {
    this.isToster = false;
  }

  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe({
      next: (res: any) => {
        let companyData = res.data;
        this.companyData = (companyData || []).filter((company: any) => company.status === 'Active');
      }
    });
  }

  sortData(header: any, index: number) {
    if (index === 2) return;

    this.headers.forEach(h => {
      if (h !== header && h.sortDir !== undefined) {
        delete h.sortDir;
      }
    });

    let nextSortDir: number | undefined;
    if (header.sortDir === 1) {
      nextSortDir = -1;
    } else if (header.sortDir === -1) {
      nextSortDir = undefined;
    } else {
      nextSortDir = 1;
    }

    if (nextSortDir) {
      header.sortDir = nextSortDir;
    } else {
      delete header.sortDir;
    }

    const sortParams: any = {};

    if (nextSortDir) {
      if (index === 0 || index === 1) {
        let sortValue = header.value.replaceAll(/\s+/g, "");
        if (sortValue.toLowerCase() === 'brand') {
          sortValue = 'tyreMake';
        }
        sortParams.sort = sortValue.charAt(0).toLowerCase() + sortValue.slice(1);
        sortParams.sortDir = nextSortDir;

      } else if (index > 2) {
        sortParams.sortingBranchId = header.key;
        sortParams.sortDirection = nextSortDir;
      }
    }
    this.sortCompanyStockDetails(sortParams);
  }
  
  sortCompanyStockDetails(sortParams: any = {}) {
    this.loader = true;
    const params = {
      ...this.filters,
      ...sortParams
    };
    if (this.stockSub) {
      this.stockSub.unsubscribe();
    }
    this.stockSub = this.dashboardService.getCompanyStockDetails(this.stockDts, params).subscribe({
      next: (res: any) => {
        this.data = res?.data?.data || [];
        if (res?.data?.headers) {
          const currentSortHeader = this.headers?.find(h => h.sortDir !== undefined);
          this.headers = res.data.headers.map((newH: any) => {
            if (currentSortHeader) {
              if (newH.key && newH.key === currentSortHeader.key) {
                newH.sortDir = currentSortHeader.sortDir;
              } else if (newH.value && newH.value === currentSortHeader.value) {
                newH.sortDir = currentSortHeader.sortDir;
              }
            }
            return newH;
          });
        }
        this.loader = false;
      },
      error: () => {
        this.loader = false;
      }
    });
  }
  
  inputChangeFilter() {
    this.filterSubject$.next();
  }

  onChangeApplyFilter() {
    this.filters = Object.fromEntries(
      Object.entries(this.filtersForm).filter(
        ([key, value]) => value !== '' && value !== null && value !== 'all'
      )
    );
    this.getAllCompanyStock();
  }

  openFilterPanel() {
    this.showFilterPanel = !this.showFilterPanel;
  }

  trackById(index: number, item: any) {
    return item ? item._id : index;
  }

  protected faDownload = faDownload;
  protected faEye = faEye;
  protected faArrowUp = faArrowUp;
  protected faArrowDown = faArrowDown;
  protected faSort = faSort;
  protected faLoader = faSpinner;
  protected faSliders = faSliders;
  protected faAngleDown = faAngleDown;
  protected faAngleUp = faAngleUp;
}
